import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ProductRetrocessionModel} from '../productRetrocession.model';
import {Injectable} from '@angular/core';
import {ProductSummaryConverter} from '../../../../api/entity/converter/productSummary.converter';
import {ProductRetrocessionRuleConverter} from './productRetrocessionRule.converter';
import {ProductRetrocessionRetrocessionConverter} from './productRetrocessionRetrocession.converter';

@Injectable()
export class ProductRetrocessionConverter extends HttpModelConverter<ProductRetrocessionModel> {

    constructor(private productConverter: ProductSummaryConverter,
                private retrocessionConverter: ProductRetrocessionRetrocessionConverter) {
        super();
    }

    protected createInstance(): ProductRetrocessionModel {
        return new ProductRetrocessionModel();
    }

    protected enrichObject(result: ProductRetrocessionModel, src: ProductRetrocessionModel) {
        result.retrocessions = this.retrocessionConverter.convertFromArray(src.retrocessions);
        result.product = this.productConverter.convert(src.product);
    }
}
